import React, { FC } from 'react';
import { Provider } from 'react-redux';
import { AUPortal, LangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import LoginWrapperComponent from '../components/login-menu/LoginWrapperComponent';
// import MenuWrapperComponent from '../components/login-menu/MenuWrapperComponent';
import SystemMessagesWrapperComponent from '../components/system-messages/SystemMessagesWrapperComponent';
import { setupStore } from '../store/configureStore';

const store = setupStore();

const AppWrapperComponent: FC = () => (
  <AUPortal.Provider name="minansoegning">
    <LangContext.Provider value={window.appLang}>
      <Provider store={store}>
        <SystemMessagesWrapperComponent />
        <LoginWrapperComponent />
      </Provider>
    </LangContext.Provider>
  </AUPortal.Provider>
);

AppWrapperComponent.displayName = 'AppWrapperComponent';
export default AppWrapperComponent;
